import "./styles/footer.css";

function Footer() {
    return (
        <footer className="footer-section">
            <div className="footer-content">
                <div className="footer-brand">
                <p className="footer-name">Joel Reji George</p>

                <blockquote className="footer-quote">
                    “Simplicity is the soul of efficiency.” – Austin Freeman
                </blockquote>

                <p className="footer-copy">
                    © {new Date().getFullYear()} Joel George. All rights reserved.
                </p>
                </div>

                <div className="footer-links">
                    <a href="mailto:joel@example.com" className="footer-link">
                        <img src="/logos/email.png" alt="Email" className="footer-icon" />
                    </a>
                    <a href="https://www.linkedin.com/in/joelgeorge" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <img src="/logos/linkedin.png" alt="LinkedIn" className="footer-icon" />
                    </a>
                    <a href="https://github.com/joelgeorge" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <img src="/logos/github.png" alt="GitHub" className="footer-icon" />
                    </a>
                </div>

                <div className="footer-legal">
                    <a href="/privacy">Privacy Policy</a>
                    <span>•</span>
                    <a href="/terms">Terms</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;